// ✅ FORCE CONFIG TO LOAD - MUST BE FIRST
import './config';

// ✅ ALSO IMPORT IT AGAIN TO PREVENT TREE-SHAKING
import { API_BASE_URL, SERVER_ORIGIN } from './config';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ✅ USE THE IMPORTED VALUES SO WEBPACK KNOWS THEY'RE NEEDED
console.log('🌐 API_BASE_URL:', API_BASE_URL);
console.log('🌐 SERVER_ORIGIN:', SERVER_ORIGIN);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();